export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '投掷骰子列表';
